(function () {
  var SCHMOOZY_PROXY_URL =
    "https://phpstack-1615213-6416084.cloudwaysapps.com/schmoozy-jobs-proxy.php";

  function escapeHtml(value) {
    if (value == null) return "";

    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function parseManualJobs(value) {
    if (!value) return [];

    return String(value)
      .split(/\r?\n/)
      .map(function (line) {
        return line.trim();
      })
      .filter(Boolean)
      .map(function (line) {
        var parts = line.split("|").map(function (part) {
          return part.trim();
        });

        return {
          title: parts[0] || "Untitled role",
          location: parts[1] || "",
          url: parts[2] || ""
        };
      })
      .filter(function (job) {
        return job.title && job.url;
      });
  }

  function normalizeGreenhouseJob(job, careersUrl) {
    return {
      title: job.title || "Untitled role",
      url: job.absolute_url || careersUrl,
      location: job.location && job.location.name ? job.location.name : ""
    };
  }

  function normalizeLeverJob(job, careersUrl) {
    return {
      title: job.text || "Untitled role",
      url: job.hostedUrl || job.applyUrl || careersUrl,
      location: job.categories && job.categories.location ? job.categories.location : ""
    };
  }

  function normalizeAshbyJob(job, careersUrl) {
    return {
      title: job.title || "Untitled role",
      url: job.jobUrl || job.applyUrl || careersUrl,
      location: job.location || ""
    };
  }

  function normalizeSmartRecruitersJob(job, careersUrl, slug) {
    return {
      title: job.name || "Untitled role",
      url:
        "https://jobs.smartrecruiters.com/" +
        encodeURIComponent(slug) +
        "/" +
        encodeURIComponent(job.id),
      location: job.location
        ? [job.location.city, job.location.region || job.location.regionCode, job.location.country]
            .filter(Boolean)
            .join(", ")
        : ""
    };
  }

  function normalizeRecruiteeJob(job, careersUrl) {
    return {
      title: job.title || "Untitled role",
      url: job.careers_url || job.careers_apply_url || careersUrl,
      location: [job.city, job.country_code || job.country].filter(Boolean).join(", ")
    };
  }

  function normalizeFantasticJob(job, careersUrl) {
    return {
      title: job.title || "Untitled role",
      url: job.url || careersUrl,
      location: job.location || ""
    };
  }

  async function fetchJobsFromProxy(companyName, careersUrl) {
    if (!companyName) return [];

    var params = new URLSearchParams();

    params.set("company", companyName || "");
    params.set("location", "Canada");
    params.set("limit", "5");

    var response = await fetch(SCHMOOZY_PROXY_URL + "?" + params.toString());

    if (!response.ok) return [];

    var data = await response.json();

    return Array.isArray(data.jobs)
      ? data.jobs.map(function (job) {
          return normalizeFantasticJob(job, careersUrl);
        })
      : [];
  }

  async function fetchJobs(provider, slug, careersUrl, companyName) {
    if (!provider) return [];

    provider = provider.toLowerCase().trim();

    if (provider === "fallback") return [];

    if (provider === "fantastic") {
      return await fetchJobsFromProxy(companyName, careersUrl);
    }

    if (!slug) return [];

    if (provider === "greenhouse") {
      var greenhouseRes = await fetch(
        "https://boards-api.greenhouse.io/v1/boards/" +
          encodeURIComponent(slug) +
          "/jobs?content=false"
      );

      if (!greenhouseRes.ok) return [];

      var greenhouseData = await greenhouseRes.json();

      return Array.isArray(greenhouseData.jobs)
        ? greenhouseData.jobs.map(function (job) {
            return normalizeGreenhouseJob(job, careersUrl);
          })
        : [];
    }

    if (provider === "lever") {
      var leverRes = await fetch(
        "https://api.lever.co/v0/postings/" +
          encodeURIComponent(slug) +
          "?mode=json"
      );

      if (!leverRes.ok) return [];

      var leverData = await leverRes.json();

      return Array.isArray(leverData)
        ? leverData.map(function (job) {
            return normalizeLeverJob(job, careersUrl);
          })
        : [];
    }

    if (provider === "ashby") {
      var ashbyRes = await fetch(
        "https://api.ashbyhq.com/posting-api/job-board/" +
          encodeURIComponent(slug) +
          "?includeCompensation=false"
      );

      if (!ashbyRes.ok) return [];

      var ashbyData = await ashbyRes.json();

      return Array.isArray(ashbyData.jobs)
        ? ashbyData.jobs.map(function (job) {
            return normalizeAshbyJob(job, careersUrl);
          })
        : [];
    }

    if (provider === "smartrecruiters") {
      var smartRes = await fetch(
        "https://api.smartrecruiters.com/v1/companies/" +
          encodeURIComponent(slug) +
          "/postings?limit=20"
      );

      if (!smartRes.ok) return [];

      var smartData = await smartRes.json();

      return Array.isArray(smartData.content)
        ? smartData.content.map(function (job) {
            return normalizeSmartRecruitersJob(job, careersUrl, slug);
          })
        : [];
    }

    if (provider === "recruitee") {
      var recruiteeRes = await fetch(
        "https://" + encodeURIComponent(slug) + ".recruitee.com/api/offers/"
      );

      if (!recruiteeRes.ok) return [];

      var recruiteeData = await recruiteeRes.json();

      return Array.isArray(recruiteeData.offers)
        ? recruiteeData.offers.map(function (job) {
            return normalizeRecruiteeJob(job, careersUrl);
          })
        : [];
    }

    return [];
  }

  function closeOtherDropdowns(currentCard) {
    document.querySelectorAll(".schmoozy-card-jobs").forEach(function (card) {
      if (card !== currentCard) {
        card.classList.remove("is-open");

        var dropdown = card.querySelector(".schmoozy-positions-dropdown");

        if (dropdown) {
          dropdown.hidden = true;
        }
      }
    });
  }

  function renderFallback(card, careersUrl) {
    var badge = card.querySelector(".schmoozy-hiring-badge");
    var button = card.querySelector(".schmoozy-positions-toggle");
    var dropdown = card.querySelector(".schmoozy-positions-dropdown");
    var fallback = card.querySelector(".schmoozy-careers-fallback");

    if (badge) badge.hidden = true;
    if (button) button.hidden = true;
    if (dropdown) dropdown.hidden = true;

    if (!fallback || !careersUrl) return;

    fallback.hidden = false;
  }

  function renderJobs(card, jobs, careersUrl) {
    var badge = card.querySelector(".schmoozy-hiring-badge");
    var button = card.querySelector(".schmoozy-positions-toggle");
    var count = card.querySelector(".schmoozy-position-count");
    var dropdown = card.querySelector(".schmoozy-positions-dropdown");
    var fallback = card.querySelector(".schmoozy-careers-fallback");

    if (!badge || !button || !count || !dropdown) return;

    if (!jobs.length) {
      badge.hidden = true;
      button.hidden = true;
      dropdown.hidden = true;

      if (fallback && careersUrl) {
        fallback.hidden = false;
      }

      return;
    }

    var visibleJobs = jobs.slice(0, 5);

    badge.hidden = false;
    button.hidden = false;

    if (fallback) {
      fallback.hidden = true;
    }

    count.textContent = "(" + jobs.length + ")";

    dropdown.innerHTML = visibleJobs
      .map(function (job) {
        var label = job.location ? job.title + " — " + job.location : job.title;

        return (
          '<a class="schmoozy-job-link" href="' +
          escapeHtml(job.url || careersUrl || "#") +
          '" target="_blank" rel="noopener">' +
          escapeHtml(label) +
          "</a>"
        );
      })
      .join("");

    if (jobs.length > 5 && careersUrl) {
      dropdown.innerHTML +=
        '<a class="schmoozy-job-link" href="' +
        escapeHtml(careersUrl) +
        '" target="_blank" rel="noopener">View all positions</a>';
    }

    if (!button.dataset.schmoozyBound) {
      button.dataset.schmoozyBound = "true";

      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();

        closeOtherDropdowns(card);

        var willOpen = dropdown.hidden;

        dropdown.hidden = !willOpen;
        card.classList.toggle("is-open", willOpen);
      });
    }
  }

  async function initSchmoozyCardJobs() {
    var cards = document.querySelectorAll(".schmoozy-card-jobs");

    cards.forEach(async function (card) {
      if (card.dataset.schmoozyInitialized === "true") return;

      card.dataset.schmoozyInitialized = "true";

      var manualJobsRaw = card.getAttribute("data-manual-jobs") || "";
      var companyName = card.getAttribute("data-company-name") || "";
      var provider = card.getAttribute("data-provider") || "";
      var slug = card.getAttribute("data-slug") || "";
      var careersUrl = card.getAttribute("data-careers-url") || "";

      var manualJobs = parseManualJobs(manualJobsRaw);

      provider = provider.toLowerCase().trim();

      if (manualJobs.length) {
        renderJobs(card, manualJobs, careersUrl);
        return;
      }

      if (!companyName && !provider && !slug && !careersUrl) {
        return;
      }

      if (!provider || provider === "fallback") {
        renderFallback(card, careersUrl);
        return;
      }

      try {
        var jobs = await fetchJobs(provider, slug, careersUrl, companyName);
        renderJobs(card, jobs, careersUrl);
      } catch (error) {
        console.log("Schmoozy jobs unavailable for:", companyName, error);

        if (careersUrl) {
          renderFallback(card, careersUrl);
        }
      }
    });

    if (!window.schmoozyCardJobsClickBound) {
      window.schmoozyCardJobsClickBound = true;

      document.addEventListener("click", function () {
        document.querySelectorAll(".schmoozy-card-jobs").forEach(function (card) {
          card.classList.remove("is-open");
        });

        document.querySelectorAll(".schmoozy-positions-dropdown").forEach(function (dropdown) {
          dropdown.hidden = true;
        });
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSchmoozyCardJobs);
  } else {
    initSchmoozyCardJobs();
  }

  document.addEventListener("shopify:section:load", function () {
    document.querySelectorAll(".schmoozy-card-jobs").forEach(function (card) {
      delete card.dataset.schmoozyInitialized;
    });

    initSchmoozyCardJobs();
  });

  document.addEventListener("shopify:section:select", function () {
    document.querySelectorAll(".schmoozy-card-jobs").forEach(function (card) {
      delete card.dataset.schmoozyInitialized;
    });

    initSchmoozyCardJobs();
  });
})();